import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import {useAppSelector} from 'src/redux/hooks';
import {TotpSetupDetails} from '../TotpSetupDetails';
import {ConfirmSignInWithTotpCode} from './ConfirmSignInWithTotpCode';

export const ContinueSignInWithTotpSetup = () => {
  const {signInNextStep, username} = useAppSelector(state => state.auth);
  if (signInNextStep?.signInStep !== 'CONTINUE_SIGN_IN_WITH_TOTP_SETUP')
    return null;
  return (
    <Stack>
      <Text fw={600}>Set up your authenticator app</Text>
      <Text size="sm" c="dimmed">
        Open your authenticator app and scan this code. Then enter the 6-digit
        code the app shows.
      </Text>
      <TotpSetupDetails
        sharedSecret={signInNextStep.totpSetupDetails.sharedSecret}
        username={username ?? 'Proact user'}
      />
      <ConfirmSignInWithTotpCode />
    </Stack>
  );
};
